import { BillLineAggregateCashInKindV2, BillLineItemV2Kind } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemCashinReceivableAggregateMock =
  new MockFactory<BillLineAggregateCashInKindV2>({
    amount_cents: 20000,
    id: 'line_item_cash_in_receivable',
    kind: BillLineItemV2Kind.AggregateCashInReceivable,
    metadata: {
      cashin_ids: ['id1', 'id2', 'id3'],
    },
    payer_id: '8e1c9e14-80cf-4b3a-b4b3-f8047625e8b9',
    reference_date: '2023-11-30T00:00:00Z',
  })
